// extracted by mini-css-extract-plugin
export default {"popup":"Tooltip--popup--4l87s","arrow":"Tooltip--arrow--Y23GV"};